module.exports = __webpack_public_path__ + "img/icon-cart.d4a579f4.svg";